import type {FC} from 'react';
import {Select} from '@wellstone-solutions/web';
import type {SelectChangeEvent} from '@mui/material';
import {useStores} from 'hooks/useStores';

interface ProgramSelectProps {
  value?: string | null;
  onChange: (value: string | null) => void;
}

interface ProgramOption {
  label: string;
  id: string;
}

const ALL_PROGRAMS_VALUE = 'all';
const ALL_PROGRAMS_LABEL = 'All Programs';

export const ProgramSelect: FC<ProgramSelectProps> = ({
  value = null,
  onChange,
}) => {
  const {meStore} = useStores();

  const programs = meStore.myPrograms
    .map((program: Record<string, string>) => ({
      label: program.name,
      value: program.id,
    }))
    .sort((a: ProgramOption, b: ProgramOption) =>
      a.label.localeCompare(b.label),
    );

  const items = [
    {label: ALL_PROGRAMS_LABEL, value: ALL_PROGRAMS_VALUE},
    ...programs,
  ];

  const selectedValue = value === null ? ALL_PROGRAMS_VALUE : value;

  return (
    <Select
      value={selectedValue}
      onChange={(event: SelectChangeEvent) => {
        const newValue =
          event.target.value === ALL_PROGRAMS_VALUE ? null : event.target.value;
        onChange(newValue);
      }}
      items={items}
      canUnselect={false}
      label="Program"
      data-testid="program-select"
      containerProps={{
        fullWidth: true,
        sx: {
          maxWidth: {
            xs: '100%',
            md: 400,
          },
        },
      }}
    />
  );
};
